import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

export const RkoAdvisoryOrgActionsCell = (props: {
  name: string;
  onUnlink: () => void;
}) => {
  const [isUnlinkOpen, toggleUnlinkOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Unlink', onSelect: toggleUnlinkOpen }]}
        trigger={
          <IconButton data-testid={`actions-${camelCase(props.name)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmColor='error'
        confirmText='Unlink'
        data-testid={camelCase(`unlink ${props.name}`)}
        isOpen={isUnlinkOpen}
        message={`Unlink ${props.name} from this record keeping organization?`}
        onCancel={toggleUnlinkOpen}
        onConfirm={() => {
          toggleUnlinkOpen();
          props.onUnlink();
        }}
        title='Unlink Advisory Organization'
      />
    </>
  );
};
